/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import AutoCard from 'components/AutoCard';
import StyledTypography from 'components/StyledTypography';
import i18n from 'i18n';
import { connect } from 'react-redux';
import { modalOpen, modalClose } from 'modules/modal/actions';
import ApplicationState from 'store/interfaces';
import { cyrb53Hash, numberWithDots } from 'utils/helpers';
import { DashboardDataCompanyPartnerFields } from 'modules/dashboard/interfaces';
import styles, { overrideCard } from './styles';

const useStyles = makeStyles(styles);

export interface PartnerDashboardCardItem {
  title: string;
  value: string | number;
  key: string;
}

interface PartnerDashboardCardProps {
  companyDashboardPartnerData: DashboardDataCompanyPartnerFields;
}

const PartnerDashboardCard: React.FC<PartnerDashboardCardProps> = ({
  companyDashboardPartnerData,
}) => {
  const classes = useStyles();

  const partnerDashboardDataLeft: PartnerDashboardCardItem[] = [
    {
      title: i18n.t('PANEL_PAGE.TOTAL_ENVIRONMENT_KEY'),
      key: 'companyDashboardPartnerData.summary.environments_count',
      value: numberWithDots(
        companyDashboardPartnerData?.summary?.environments_count
      ),
    },

    {
      title: i18n.t('PANEL_PAGE.TOTAL_ENVIRONMENT_INSTANCE_KEY'),
      key:
        'companyDashboardPartnerData.summary.environments_with_instances_count',
      value: numberWithDots(
        companyDashboardPartnerData?.summary?.environments_with_instances_count
      ),
    },
    {
      title: i18n.t('INSTANCES_KEY'),
      key: 'companyDashboardPartnerData.summary.environments_count',
      value: numberWithDots(
        companyDashboardPartnerData?.summary?.environments_count
      ),
    },
  ];

  const partnerDashboardDataRight: PartnerDashboardCardItem[] = [
    {
      title: i18n.t('PANEL_PAGE.TOTAL_CLIENTS_KEY'),
      key: 'companyDashboardPartnerData.summary.clients_count',
      value: numberWithDots(
        companyDashboardPartnerData?.summary?.clients_count
      ),
    },
    {
      title: i18n.t('PANEL_PAGE.TOTAL_USERS_KEY'),
      key: 'companyDashboardPartnerData.summary.users_count',
      value: numberWithDots(companyDashboardPartnerData?.summary?.users_count),
    },
    {
      key: 'companyDashboardPartnerData.summary.sessions_count',
      title: i18n.t('TOTAL_SESSIONS_ACTIVE_KEY'),
      value: numberWithDots(
        companyDashboardPartnerData?.summary?.sessions_count
      ),
    },
  ];

  return (
    <>
      <Grid item xs={6}>
        <Typography className={classes.titleCard}>
          {i18n.t('ACCOUNT_INFORMATION_KEY')}
          {':'}
        </Typography>
      </Grid>
      <AutoCard overrideClasses={overrideCard()}>
        <Grid container className={classes.container}>
          {partnerDashboardDataLeft?.map(item => (
            <Grid
              item
              xs={5}
              className={classes.item}
              key={cyrb53Hash(item?.title)}
            >
              <Grid item className={classes.line}>
                <Typography className={classes.title}>{item?.title}</Typography>
              </Grid>

              <Grid item className={classes.line}>
                <StyledTypography value={item?.value} />
              </Grid>
            </Grid>
          ))}
          {partnerDashboardDataRight?.map(item => (
            <Grid
              item
              xs={5}
              className={classes.item}
              key={cyrb53Hash(item?.title)}
            >
              <Grid item className={classes.line}>
                <Typography className={classes.title}>{item?.title}</Typography>
              </Grid>

              <Grid item className={classes.line}>
                <StyledTypography value={item?.value} />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </AutoCard>
    </>
  );
};

const mapStateToProps = ({
  monitor: {
    blockedEnvironmentsData,
    environmentHealthData,
    instanceStatusData,
    environmentAndCeleryQueueStatus,
  },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  blockedEnvironmentsData,
  environmentHealthData,
  instanceStatusData,
  role: data?.role,
  data: environmentAndCeleryQueueStatus,
});

export default connect(mapStateToProps, { modalOpen, modalClose })(
  PartnerDashboardCard
);
